import { type TermsMethodsKindEnum } from '@webapp/modules/purchasing/entities/enums/TermsMethodsKindEnum'
import {
  type TermOrMethod,
  type TermOrMethodEditableField,
} from '@webapp/modules/purchasing/features/edit-term-or-method/models'
import { EditableTermOrMethodTextField } from '@webapp/modules/purchasing/features/edit-term-or-method/views/EditableTermOrMethodTextField'
import { useEditableTermOrMethodTextFieldPresenter } from './useEditableTermOrMethodTextFieldPresenter'

export interface IEditableTermOrMethodTextFieldPresenterProps {
  kind: TermsMethodsKindEnum
  item: TermOrMethod
  field: TermOrMethodEditableField
  onSuccess?: (id: number) => void
}

export const EditableTermOrMethodTextFieldPresenter = ({
  kind,
  item,
  field,
  onSuccess,
}: IEditableTermOrMethodTextFieldPresenterProps) => {
  const {
    data: { inputValue, status },
    handlers: { handleChange, handleCommit, handleEscape },
  } = useEditableTermOrMethodTextFieldPresenter({
    kind,
    item,
    field,
    onSuccess,
  })

  return (
    <EditableTermOrMethodTextField
      value={inputValue}
      field={field}
      status={status}
      onChange={handleChange}
      onCommit={handleCommit}
      onEscape={handleEscape}
    />
  )
}

EditableTermOrMethodTextFieldPresenter.displayName =
  'EditableTermOrMethodTextFieldPresenter'
